import { defineRule } from 'vee-validate'
import { debounce } from 'lodash'
import { API } from '@/services/api-core.service'
import { i18n } from '@/i18n.js'

let isExist = true

const isUnique = async value => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  if (localStorage.getItem('email') !== null) {
    if (localStorage.getItem('email') === value) {
      return isExist
    } else {
      localStorage.setItem('email', value)
    }
  } else {
    localStorage.setItem('email', value)
  }

  if (re.test(String(value).toLowerCase())) {
    const response = await API.request('GET', 'api/customers', { email: value }, null, true, false)
    isExist = response.customers.length === 0
  }

  return { valid: isExist }
}

defineRule(
  'mailunique',
  debounce(async value => {
    if (await isUnique(value)) {
      return true
    }
    return i18n.global.t('form.mailExists')
  }, 1000)
)
